import { TransformerViewModel } from 'src/app/views/transformer-list/transformer-list.component';


export class TransformPipelineItem {
    name: string;
    group: string;
    statusDisplayText: string;
    isRunning: boolean;
    isActiveTransform: boolean;
    transform: TransformerViewModel;
    cacheUpdatedStatus: string;
    transformerTime: string;

    constructor(
        name: string,
        group: string,
        statusDisplayText: string,
        transform: TransformerViewModel,
        isActive: boolean,cacheUpdatedStatus: string,transformerTime: string) {

        this.name = name;
        this.group = group;
        this.statusDisplayText = statusDisplayText;
        this.transform = transform;
        this.isActiveTransform = isActive;
        this.cacheUpdatedStatus = cacheUpdatedStatus;
        this.transformerTime = transformerTime;
    }
}

export class GroupedTransformPipelineItem {
    groupName: string;
    items: TransformPipelineItem[] = [];
}

export class TransformPipelineViewModel {
    items: GroupedTransformPipelineItem[];
    currentGroup: string;
    
    getItemStatusTextColor(item: TransformPipelineItem): string {
        switch (item.statusDisplayText) {
            case 'Failed!':
                return 'red';
            case 'Completed!':
                return '#49CF43';
            case 'Pending':
                return 'gray';
            default:
                return '#ffa600';
        }
    }
}
